import React, { useState, useEffect } from 'react';
import { isEmpty, get, isArray, isNil, toLower } from 'lodash';

import templatesMapping from '../../services/blog/templatesMapping';
import NoContent from '../NoContent.jsx';

const mapContent = ({ contentType, cmsContent }) => {
    let mappedProps = {};

    if (existsTemplateMapping(contentType)) {
        if (!templatesMapping[contentType].propertiesMapping) {
            return cmsContent;
        }
        const propertiesMapping =
            templatesMapping[contentType].propertiesMapping;
        for (const cmsKey in propertiesMapping) {
            if (Object.hasOwnProperty.call(propertiesMapping, cmsKey)) {
                const element = propertiesMapping[cmsKey];
                mappedProps[element] = get(cmsContent, cmsKey);
            }
        }
        return mappedProps;
    }
    return cmsContent;
};

const existsTemplateMapping = (contentType) =>
    typeof templatesMapping[contentType] !== 'undefined';

const BlogBuilder = ({
    status,
    id,
    contenttype,
    virtualdir,
    usercultureiso,
    usercountry,
    usercurrency,
    blogpostcontent,
}) => {
    const [blogContentLoaded, setBlogContentLoaded] = useState(false);
    const [blogContent, setBlogContent] = useState({});

    useEffect(() => {
        try {
            const deserializedData = JSON.parse(blogpostcontent);
            const cmsContent = isArray(deserializedData)
                ? deserializedData[0]
                : deserializedData;
            const mappedContent = mapContent({
                contentType: contenttype,
                cmsContent: cmsContent.attributes,
            });
            setBlogContent(mappedContent);
            setBlogContentLoaded(true);
        } catch (error) {
            setBlogContentLoaded(false);
            console.error(
                `Error loading data for ${contenttype} and id ${id}: ${error} `
            );
        }
    }, []);

    const publishInProduction =
        !isNil(blogContent.creativeWorkStatus) &&
        toLower(blogContent.creativeWorkStatus) === 'published';

    const publishInPreview =
        !isNil(blogContent.creativeWorkStatus) &&
        toLower(blogContent.creativeWorkStatus) === 'draft';

    if (status === 'published' && !publishInProduction)
        return <NoContent virtualdir={virtualdir} />;

    if (status === 'draft' && !publishInPreview && !publishInProduction)
        return <NoContent virtualdir={virtualdir} />;

    const getBlogPageByContentType = (
        contentType,
        usercountry,
        usercultureiso,
        usercurrency
    ) => {
        if (
            blogContentLoaded &&
            existsTemplateMapping(contentType) &&
            !isEmpty(blogContent)
        ) {
            const Component = templatesMapping[contentType].component;
            return (
                <Component
                    virtualdir={virtualdir}
                    usercountry={usercountry}
                    usercultureiso={usercultureiso}
                    usercurrency={usercurrency}
                    {...blogContent}></Component>
            );
        }
        return <NoContent virtualdir={virtualdir} />;
    };

    return (
        <div>
            {blogContentLoaded ? (
                getBlogPageByContentType(
                    contenttype,
                    usercountry,
                    usercultureiso,
                    usercurrency
                )
            ) : (
                <NoContent virtualdir={virtualdir} />
            )}
        </div>
    );
};

export default BlogBuilder;
